// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"150":"5fe3b604","374":"3da79808","790":"560f241f"}[chunkId] + ".chunk.css";
};